/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 10:32:14
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-06-07 17:41:28
 * @FilePath: /dbrank_b/src/routes/visualChart/index.js
 * @Description: 可视化图表
 */

import React from 'react';
import Layout from './Layout';
import router from './router';

export default {

  path: '/visualChart',

  async action({ next, url, path }) {
    const child = await next()

    if (child && child.component) {
      return {
        ...child,
        component: <Layout active={url}>{child.component}</Layout>
      }
    }

    return {
      redirect: `${path}/p1`
    }
  },

  children: [
    {
      path: '/',
      action ({ url }) {
        return {
          redirect: `${url}/${router[0].path}`
        }
      }
    },
    ...router.map(({ path, title, component: IComponent }) => ({
      path: `/${path}`,
      action () {
        return { title, component: <IComponent /> }
      }
    }))
  ]
};



// WEBPACK FOOTER //
// src/routes/visualChart/index.js